// 비밀번호 변경 페이지 JavaScript
document.addEventListener('DOMContentLoaded', function() {
  // 해당 페이지가 아니면 실행하지 않음
  const currentPasswordInput = document.getElementById('currentPassword');
  if (!currentPasswordInput) {
    return; // 비밀번호 변경 페이지가 아니면 종료
  }
  // 페이지 로드 시 초기화
});

// 비밀번호 변경 처리
function handlePasswordChange(e) {
  if (e && e.preventDefault) e.preventDefault();
  
  const currentPassword = document.getElementById('currentPassword').value;
  const newPassword = document.getElementById('newPassword').value;
  const newPasswordConfirm = document.getElementById('newPasswordConfirm').value;
  
  // 유효성 검사
  if (!currentPassword) {
    alert('현재 비밀번호를 입력해주세요.');
    return;
  }
  
  if (!newPassword) {
    alert('새 비밀번호를 입력해주세요.');
    return;
  }
  
  if (newPassword !== newPasswordConfirm) {
    alert('새 비밀번호가 일치하지 않습니다.');
    return;
  }
  
  if (currentPassword === newPassword) {
    alert('현재 비밀번호와 새 비밀번호가 같습니다.');
    return;
  }
  
  // TODO: 실제 API 연동
  
  // 임시 처리
  alert('비밀번호가 변경되었습니다.');
  
  // 폼 초기화
  document.getElementById('currentPassword').value = '';
  document.getElementById('newPassword').value = '';
  document.getElementById('newPasswordConfirm').value = '';
  
  // 마이페이지로 이동 (선택사항)
  // window.location.href = 'so_c4000.html';
}
